import SVG from "../../../Components/SVG";
export default function StatusColorful({SVGName, SVGClassName="", text, className="", color}) {
  const colorMap = {
    blue: {
      light: "#DFEBF1",
      dark: "#2878A3"
    },
    yellow: {
      light: "#F9F2DE",
      dark: "#D2A924"
    },
    green: {
      light: "#DCF2E4",
      dark: "#15A946"
    },
    red: {
      light: "#F9DEDE",
      dark: "#D71F1F"
    },
    gray: {
      light: "#E5E5E5",
      dark: "#ACACAC"
    }
  };
  const selected = colorMap[color];

  return (
    <span className={`py-1 px-1.5 rounded-md text-xs font-light text-nowrap flex items-center justify-start gap-2.5 ${className} dark:[--bg-active:var(--bg-dark)] [--bg-active:var(--bg-light)] dark:[--ring-active:var(--bg-light)] [--ring-active:var(--bg-dark)] [--p1-fill:var(--p1-light)] dark:[--p1-fill:var(--p1-dark)] [--p2-fill:var(--p2-light)] dark:[--p2-fill:var(--p2-dark)]`}
      style={{ backgroundColor: "var(--bg-active)", "--bg-light": selected.light, "--bg-dark": selected.dark, color: selected.dark}}>
      <SVG name={SVGName} 
        classname={`${SVGClassName} dark:[--fill-active:var(--bg-light)] [--fill-active:var(--bg-dark)] dark:[--stroke-active:var(--bg-dark)] [--stroke-active:var(--bg-light)]`} 
        style={{fill: "var(--fill-active)", stroke: "var(--stroke-active)",}}/>
      <span className={`dark:[--text-active:var(--bg-light)] [--text-active:var(--bg-dark)]`}
        style={{color: "var(--text-active)"}}>
        {text}
      </span>
    </span>
  )
}